import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ESliceNames } from '~/store/types';

interface InsightPosthogState {
  organizationId?: string;
  ecosystemId?: string;
  embedUrl?: string;
  _id?: string;
}

const initialState: InsightPosthogState = {
  organizationId: undefined,
  ecosystemId: undefined,
  embedUrl: undefined,
  _id: undefined,
};

export const insightPosthogSlice = createSlice({
  name: ESliceNames.INSIGHT_POSTHOG,
  initialState,
  reducers: {
    setInsightPosthog: (
      state,
      { payload }: PayloadAction<InsightPosthogState>,
    ) => {
      return {
        ...state,
        ...payload,
      };
    },
    reset: () => {
      return initialState;
    },
  },
});

export const {
  reducer: insightPosthogSliceReducer,
  actions: insightPosthogSliceActions,
} = insightPosthogSlice;
